import { render, staticRenderFns } from "./fix.vue?vue&type=template&id=33e32bec&scoped=true"
import script from "./fix.vue?vue&type=script&lang=js"
export * from "./fix.vue?vue&type=script&lang=js"
import style0 from "./fix.vue?vue&type=style&index=0&id=33e32bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e32bec",
  null
  
)

export default component.exports